import { getAuth } from 'firebase/auth';

export default {
    getIdToken: async function () {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            try {
                const payload = await user.getIdToken();
                return payload;
            } catch (err) {
                throw err;
            }
        } else {
            return Promise.resolve('notLoggedIn'); // 2025.05.12 sshoff: The value according to Backend::\vt\library\accounts\BearerTokenService::FRONTEND_DOES_NOT_HAVE_TOKEN.
        }
    },

}
